module.exports = __webpack_public_path__ + "img/prize-icon.7a1f3a29.png";